import { gql } from 'apollo-boost'

export const START_QUERY = gql`
  {
    questions {
      id
      type
      order
      question
      category
      options {
        value
        order
      }
      filterRef {
        id
      }
      theming {
        color
        accent
      }
    }
    products {
      id
      title
      description
      categories
      externalLink {
        url
      }
      picture
      price {
        amount
      }
      subProducts
      callToAction
    }
    contentConfig {
      digest {
        downloadCardBtnText
        printHandBtnText
        productsHeader
        shareHeader
        shareInstruct
        subscribeBtnText
        orgasmCardTitle
        orgasmCardSubTitle
      }
    }
  }
`

export const UPDATE_RESULT_HAND_MUTATION = gql`
  mutation UpdateResultHand($params: UpdateResultHandInput!) {
    updateResultHand(params: $params) {
      color
      animal
    }
  }
`

export const CREATE_RESPONSE_MUTATION = gql`
  mutation CreateResult($result: ResultInput!) {
    createResult(result: $result) {
      id
      hand {
        color
        animal
        cards {
          question {
            id
          }
          type
          tip
          ways
          category
          pressure {
            label
            value
          }
          speed {
            label
            value
          }
        }
      }
    }
  }
`
